import { render, staticRenderFns } from "./medicos.vue?vue&type=template&id=1ee7b38a&"
import script from "./medicos.vue?vue&type=script&lang=js&"
export * from "./medicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports